import React from "react";
import SiteLayout from "../components/SiteLayout";
import StatsBar from "../components/sections/StatsBar";
import CTASection from "../components/sections/CTASection";

export default function About() {
  return (
    <SiteLayout>
      <section className="pt-20 pb-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 max-w-3xl">
          <div className="eyebrow mb-4">About Zenith Ranking</div>
          <h1 className="font-display text-5xl sm:text-6xl font-bold tracking-tight">A quiet workspace for serious SEO work.</h1>
          <p className="mt-6 text-inkSoft text-lg leading-relaxed">
            Zenith Ranking exists for the agencies and in-house teams who want SEO and Digital PR to actually ship — not get stuck in proposals and Slack threads. We productize everything from link building to technical fixes, fix the price, and put your client deliverables behind a single dashboard.
          </p>
        </div>
      </section>

      <section className="py-12 border-y border-line bg-surfaceAlt/50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { t: "Transparency", b: "Fixed prices, fixed scopes, fixed turnarounds. Link building on real publishers, never PBNs." },
            { t: "Quality", b: "Editorial-led content and outreach. We refuse what won't earn long-term value." },
            { t: "Scalability", b: "From single placements to 100+ links a month — same workspace, same SLA." },
          ].map((p) => (
            <div key={p.t} className="card-soft p-7">
              <div className="font-display text-2xl font-semibold tracking-tight">{p.t}</div>
              <p className="mt-3 text-sm text-inkSoft leading-relaxed">{p.b}</p>
            </div>
          ))}
        </div>
      </section>

      <StatsBar />

      <section className="py-20">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <div className="eyebrow mb-3">Our team</div>
          <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight">Operators who've sat on both sides of the brief.</h2>
          <p className="mt-4 text-inkSoft leading-relaxed">
            Our editors, outreach specialists and SEO engineers have run campaigns for global SaaS, niche e-commerce, and local service brands. We built Zenith Ranking because we needed it ourselves.
          </p>
        </div>
      </section>

      <CTASection />
    </SiteLayout>
  );
}
